__turbopack_context__.v({
  "card": "index-module-scss-module__xbaRKW__card",
  "checkbox": "index-module-scss-module__xbaRKW__checkbox",
  "checkboxChecked": "index-module-scss-module__xbaRKW__checkboxChecked",
  "divider": "index-module-scss-module__xbaRKW__divider",
  "error": "index-module-scss-module__xbaRKW__error",
  "label": "index-module-scss-module__xbaRKW__label",
  "required": "index-module-scss-module__xbaRKW__required",
  "row": "index-module-scss-module__xbaRKW__row",
  "section": "index-module-scss-module__xbaRKW__section",
  "termsLink": "index-module-scss-module__xbaRKW__termsLink",
  "title": "index-module-scss-module__xbaRKW__title",
});
